import type { MessageMailMode } from "./api";

/** SO-1382: a whole number of metres in the limits, or the words of the problem. */
export function parseFarM(text: string, min: number, max: number): number | string {
  const value = Number(text.trim());
  if (!text.trim() || !Number.isInteger(value) || value < min || value > max) return `Enter a whole number from ${min} to ${max}.`;
  return value;
}

/** The save body. An older API refuses `enabled`, so it goes only when the loaded setting has it. */
export function placeCheckBody(loaded: { enabled?: boolean }, farM: number, enabled: boolean): { far_m: number; enabled?: boolean } {
  return loaded.enabled === undefined ? { far_m: farM } : { far_m: farM, enabled };
}

export function awayCheckText(enabled: boolean | undefined, farM: number): string {
  if (enabled === false) return "The away check is off. The app does not ask the driver, and Review lists no new away entry.";
  return `The app asks the driver to confirm an entry saved more than ${farM} m from the stop pin.`;
}

/** SO-1474: who gets the mail of a new customer message. */
export function messageMailText(mode: MessageMailMode): string {
  if (mode === "off") return "A new customer message sends no mail. It shows only on Customer messages.";
  const who =
    mode === "salesperson" ? "the salesperson of the account, else each operations manager and administrator" : "each operations manager and administrator";
  return `A new customer message sends a mail to ${who}.`;
}
